module.exports = __webpack_public_path__ + "media/cloud.4af10e68.mp3";